import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Area  } from '@ant-design/charts';
import { Button, DatePicker, Space } from 'antd';
import moment from 'moment';



const { RangePicker } = DatePicker;

const AllWallet = () => {

  const [balanceData, setBalanceData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedRange, setSelectedRange] = useState('1D');



  useEffect(() => {
    filterDataByRange(selectedRange);
  }, [balanceData, selectedRange]);

  const filterDataByRange = (range) => {
    const end = moment();
    let start;

    switch (range) {
      case '1D':
        start = moment().subtract(1, 'days');
        break;
      case '7D':
        start = moment().subtract(7, 'days');
        break;
      case '30D':
        start = moment().subtract(30, 'days');
        break;
      case '180D':
        start = moment().subtract(180, 'days');
        break;
      case '360D':
        start = moment().subtract(360, 'days');
        break;
      default:
        start = moment().subtract(1, 'days');
    }

    const filtered = balanceData.filter(entry => {
      const timestamp = moment(entry.timestamp);
      return timestamp.isBetween(start, end, null, '[]');
    });
    setFilteredData(filtered);
  };

  const handleRangeChange = (range) => {
    setSelectedRange(range);
  };

  const prepareChartData = (data) => {
    const chartData = [];
    data.forEach(entry => {
      const futuresBalance = entry.balance.find(balance => balance.asset === 'USDT');
      if (futuresBalance) {
        chartData.push({
          timestamp: entry.timestamp,
          balance: parseFloat(futuresBalance.free),
        });
      }
    });
    return chartData;
  };

  const config = {
    data: prepareChartData(filteredData),
    xField: 'timestamp',
    yField: 'balance',
    xAxis: {
      type: 'time',
    },
    yAxis: {
      title: {
        text: 'Balance (USD)',
      },
    },
    tooltip: {
      formatter: datum => ({
        name: 'USD Balance',
        value: `$${datum.balance}`,
      }),
    },
    smooth: true,
    areaStyle: {
      fill: 'l(270) 0:rgba(255, 0, 0, 0.1) 1:rgba(255, 0, 0, 0.5)',
    },
  };

  return (
    <div>
      <h1>Futures Wallet Balance Overview</h1>
      <Space direction="horizontal" size={12}>
        <Button onClick={() => handleRangeChange('1D')}>1D</Button>
        <Button onClick={() => handleRangeChange('7D')}>7D</Button>
        <Button onClick={() => handleRangeChange('30D')}>30D</Button>
        <Button onClick={() => handleRangeChange('180D')}>180D</Button>
        <Button onClick={() => handleRangeChange('360D')}>360D</Button>
      </Space>
      <Area {...config} />
    </div>
  );
}

export default AllWallet